/**
 * Resolve scrollable content bounds for minimap scaling.
 * Falls back to safe defaults when external bounds are missing or invalid.
 */
export function getContentBounds(externalBounds) {
  if (
    externalBounds &&
    isFinite(externalBounds.width) &&
    externalBounds.width > 0 &&
    isFinite(externalBounds.height) &&
    externalBounds.height > 0
  ) {
    return externalBounds;
  }
  return { minX: 0, minY: 0, maxX: 400, maxY: 300, width: 400, height: 300 };
}
